module.exports = __webpack_public_path__ + "img/teacherTrain-2.b639e1bb.jpg";